function TestimonialSlider($el) {
    this.$el = $el || null;

    this.isExperienceEditor = $('.is-experience-editor').length;

    if (this.$el.length) {
        this.setupDefaults();
        this.addListeners();
    }
};

TestimonialSlider.prototype.setupDefaults = function () {
    this.dom = {
        $slider: this.$el.find('.pl-testimonial-slider__slider-wrapper')
    }
};

TestimonialSlider.prototype.init = function () {
    if (!this.isExperienceEditor) {
        if (typeof $.fn.slick === 'function') {
            this.dom.$slider.slick({
                speed: 888,
                infinite: true,
                easing: 'easeOutQuart',
                dots: true,
                arrows: false,
                centerMode: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                autoplay: false,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        variableWidth: false,
                        centerMode: false
                    }
                }]
            });
        }
    } else {
        this.$el.addClass('partner-lander-testimonial-slider--is-experience-editor');
    }

};

TestimonialSlider.prototype.addListeners = function () {
    var _this = this;
    $(document).ready(function () {
        _this.init();
    });
};

(function ($) {
    new TestimonialSlider($('.partner-lander-testimonial-slider'));
})(jQuery);